/**
 * EvalBreadcrumb — `Eval Groups > Group > Task > Run` trail.
 *
 * Every eval viewer screen shares the same shell; the breadcrumb is how
 * the user moves back up the Group → Task → Run hierarchy.
 */

import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'

export interface Crumb {
  label: string
  to?: string
}

export function EvalBreadcrumb({ crumbs }: { crumbs: Crumb[] }): React.JSX.Element {
  return (
    <nav aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-muted-foreground">
        {crumbs.map((crumb, i) => (
          <li key={`${crumb.label}-${String(i)}`} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="h-3.5 w-3.5" aria-hidden="true" />}
            {crumb.to ? (
              <Link to={crumb.to} className="hover:text-foreground hover:underline">
                {crumb.label}
              </Link>
            ) : (
              <span aria-current="page" className="text-foreground">
                {crumb.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
